module.exports = __webpack_public_path__ + "static/media/peopleWoman.089bfa10.svg";